import React from "react";
import { Alert, Avatar, Button, List, Modal } from "antd";
import { EmailDetails } from "./EmailDetails";
import { transactionLaneDataHandle } from "../../Rtd/state/actions";
import { useDispatch } from "react-redux";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { generateInitialsFromObj } from "../utils/universalFuntions";

const AddEmail = ({ enterEmailModal, setEnterEmailModal, form, handleAddEmail, clickedDataEmail, role, selectedData, userAuthKey, source, offerId, rootDocData, setCallPropertyDocsApi }) => {
  const dispatch = useDispatch()

  const handleAddEmailToCRM = ({ values, check }) => {
    let urlData = {
      addToProperty: false,
      offerId: ["CONTRACT_NAV_SELLER_AGENT", "CONTRACT_NAV_BUYER_AGENT", "TRANSACTION_CALENDAR"].includes(source) ? offerId : selectedData?.offerId,
      ...((source === "CONTRACT_NAV_BUYER_AGENT" || ((source === "TRANSACTION_CALENDAR" || source === "AVATAR_DATA" || source === "AVATAR_PAGE_REFRESH") && rootDocData?.openFor === "BUYER_AGENT"))
      ? {
          buyerDetail: {
            fullName: clickedDataEmail?.personId?.fullName ? clickedDataEmail?.personId?.fullName : clickedDataEmail?.fullName,
            ...(clickedDataEmail?.personId?._id ? {
              personId: clickedDataEmail?.personId?._id
            } : {
              key: clickedDataEmail?.key ? clickedDataEmail?.key : clickedDataEmail?._id,
              isCorp: clickedDataEmail?.isCorp,
              corpKey: clickedDataEmail.corpKey,
            }),
            ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
          },
          openFor: "BUYER_AGENT"
        }
      : {
          sellerDetail: {
            fullName: clickedDataEmail?.personId?.fullName ? clickedDataEmail?.personId?.fullName : clickedDataEmail?.fullName,
            key: clickedDataEmail?.key ? clickedDataEmail?.key : clickedDataEmail?._id,
            isCorp: clickedDataEmail?.isCorp,
            corpKey: clickedDataEmail.corpKey,
            ...(values?.email?.length > 0 ? { email: values?.email?.toLowerCase() } : {}),
          },
          openFor: "SELLER_AGENT"
        }),
      ...(values?._id ? { selectedId: values?._id } : {}),
      ...(check ? { newClient: true } : {})
    };

    Modal.confirm({
      title: `Are you sure you want to ${!check ? "select this contact?" : "create new contact?"}`,
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        dispatch(transactionLaneDataHandle.addEmailFun({ data: urlData, userAuthKey, source, setCallPropertyDocsApi }));
        setEnterEmailModal({ ...enterEmailModal, visible: false, data: {} });
        form?.resetFields();
      },
      onCancel() { },
    });
  };

  const handleCancelModal = () => {
    setEnterEmailModal({ ...enterEmailModal, visible: false, data: {} })
    form?.resetFields();
  }

  return (
    <>
      {/* Modal for adding the email  */}
      <Modal visible={enterEmailModal?.visible} footer={false}
        title={
          <div>
            <p style={{ textAlign: "center", color: "#178DFA", fontSize: "22px", fontWeight: "bold" }}>
              {enterEmailModal?.inValid ? "Enter Valid Email" : enterEmailModal?.data?.showClients ? "Duplicate Contacts Found" : "Add Email"}
            </p>
            {enterEmailModal?.data?.showClients && <Alert
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "center",
                width: "100%",
                margin: "auto"
              }}
              message="Please select if current contact exists from the list below or create a new contact from contact section."
              type="info"
              showIcon
            />}
          </div>}
        onCancel={handleCancelModal}>
        {/* <EmailDetails form={form} onFinish={handleAddEmail} /> */}

        {enterEmailModal?.data?.showClients ? (
          <div
            style={{ height: "400px", overflow: "hidden", overflowY: "auto" }}
          >
            <List
              itemLayout="horizontal"
              dataSource={enterEmailModal?.data?.allClients}
              renderItem={(item) => (
                <List.Item
                  onClick={() => handleAddEmailToCRM({ values: { email: form?.getFieldValue("email"), _id: item?._id }, check: false })}
                  style={{ padding: 5, borderRadius: "5px", cursor: "pointer" }}
                  hoverable
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#a8c5dc";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "white";
                  }}
                >
                  <List.Item.Meta
                    avatar={
                      item?.profileImg?.original ? (
                        <Avatar
                          style={{ background: "#085191" }}
                          src={item?.profileImg?.original}
                          size={55}
                        />
                      ) : (
                        <Avatar style={{ background: "#085191" }} size={55}>
                          {generateInitialsFromObj(item)}
                        </Avatar>
                      )
                    }
                    title={item?.fullName}
                    description={item?.email && <span>{item.email}</span>}
                  />
                </List.Item>
              )}
            />
          </div>
        ) : (
          <EmailDetails onFinish={handleAddEmail} setEnterEmailModal={setEnterEmailModal} form={form} enterEmailModal={enterEmailModal}/>
        )}

      </Modal>
    </>
  );
};

export default AddEmail;
